import React, { useEffect } from "react";
import Banner from "../components/Home/Banner/Banner";

import Hiring from "../components/Home/Hiring/Hiring";
import axios from "axios";
import PageWrapperLayout from "../layouts/PageWrapperLayout/PageWrapperLayout";
import ReactGA from "react-ga";
import { Helmet } from "react-helmet";
import { useQuery } from "react-query";
import { Modal } from "@mui/material";
import { MdClose, MdError } from "react-icons/md";
import { useSearchParams } from "react-router-dom";

import api from "api";

import Apiurl from "../Apiurl/Apiurl";
import Promo from "../components/common/Modals/Promo";
import PageLoader from "../utils/PageLoader";
import RecordedMc from "components/Home/MasterClass/RecordedMc";
import LatestCourse from "components/Home/LatestCourse/LatestCourse";
import WheelModal from "components/Modals/WheelModal";
import useAuthToken from "hooks/useAuthToken";
import useAuthModal from "hooks/useAuthModal";
import { AuthModal } from "components/Modals/AuthModal";
import FreeCourseClass from "components/Home/FreeCourseClass/FreeCourseClass";

const CompanysPartner = React.lazy(() =>
  import("../components/Home/CompanysPartner")
);
const Review = React.lazy(() => import("../components/Home/Review/Review"));
const Grow = React.lazy(() => import("../components/Home/Grow/Grow"));
const UpcomingMc = React.lazy(() =>
  import("../components/Home/MasterClass/UpcomingMc")
);

export default function Home({
  setOpenPromo,
  openPromo,
  promoImage,
  setImage,
}) {
  const [wheelOpen, setWheelOpen] = React.useState(false);
  const { authToken } = useAuthToken();
  const [searchParams] = useSearchParams();
  const { isModalOpen, openModal, closeModal } = useAuthModal();
  const [errorOpen, setErrorOpen] = React.useState(false);

  const { data } = useQuery({
    queryKey: ["free-class"],
    queryFn: api.course.getFreeClasss,
  });

  const { refetch, isError, error } = useQuery({
    queryKey: ["check-wheel-session"],
    queryFn: () =>
      api.payment.wheelCampaign({
        session_key: searchParams.get("session_key"),
      }),
    onSuccess: () => {
      setWheelOpen(true);
    },
    onError: () => {
      setErrorOpen(true);
    },
    enabled: false,
    retry: false,
  });

  const getPromo = async () => {
    try {
      const res = await axios.get(Apiurl.Baseurl + `payment/promo-image/`);
      setImage(res?.data);
    } catch (err) {
      return;
    }
  };

  useEffect(() => {
    getPromo();
    ReactGA.pageview(window.location.pathname + window.location.search);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const wheel_token = searchParams.get("session_key");
    if (wheel_token) {
      if (!authToken) {
        openModal();
      } else {
        refetch();
      }
    }
  }, [authToken, searchParams, refetch, openModal]);

  const canonicalLink = window.location.href;

  const handleClose = () => {
    setErrorOpen(false);
  };

  return (
    <>
      <Helmet>
        <title>Interactive Cares - Upskill for a Better Career</title>
        <link rel="canonical" href={canonicalLink} />

        <meta
          property="og:title"
          content="Interactive Cares - Upskill for a
Better Career"
        />
        <meta
          property="og:description"
          content="Interactive Cares is Bangladesh’s top online learning platform with 100,000+ students, offering courses in programming, UI-UX Design, Marketing, Data Science, and more"
        />
        <meta
          property="og:image"
          content="https://interactivecaresbucket.s3.ap-southeast-1.amazonaws.com/main-frontend/assets/icbanner.webp"
        />
      </Helmet>
      <>
        <PageWrapperLayout>
          <div className="bg-[#16152F]">
            <div className="relative z-10">
              {promoImage?.promo_image && (
                <Promo
                  setOpen={setOpenPromo}
                  open={openPromo}
                  banner={promoImage}
                />
              )}
              <Banner />
              <LatestCourse />

              <React.Suspense fallback={<PageLoader />}>
                <UpcomingMc />
              </React.Suspense>
              <React.Suspense fallback={<PageLoader />}>
                <RecordedMc />
              </React.Suspense>
              {data?.length !== 0 && <FreeCourseClass />}
              <React.Suspense fallback={<PageLoader />}>
                <Grow />
              </React.Suspense>

              <CompanysPartner />
              <Hiring />

              <React.Suspense fallback={<PageLoader />}>
                <Review />
              </React.Suspense>
            </div>
          </div>
        </PageWrapperLayout>
      </>
      {isError && (
        <Modal open={errorOpen} onClose={handleClose}>
          <div className="fixed inset-0 bg-black/25 flex items-center justify-center p-4">
            <div className="bg-white rounded-lg shadow-lg w-full max-w-sm relative">
              <button
                onClick={handleClose}
                className="absolute right-4 top-4 text-black transition-colors"
              >
                <MdClose size={20} />
              </button>

              <div className="p-6 flex flex-col items-center gap-3">
                <div className="w-12 h-12 rounded-full bg-rose-100 flex items-center justify-center">
                  <MdError className="w-8 h-8 text-rose-500" />
                </div>

                <p className="text-gray-900 text-center text-[18px]">
                  {error.message}
                </p>
                <button
                  onClick={handleClose}
                  className="mt-2 w-full bg-red-600 text-white py-3 px-4 rounded-md hover:bg-red-700 transition-colors text-[18px]"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </Modal>
      )}

      {wheelOpen && <WheelModal open={wheelOpen} setOpen={setWheelOpen} />}
      {isModalOpen && <AuthModal onClose={closeModal} />}
    </>
  );
}
